var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import userClient from '../config/api/userClient';
var getTemplateByPublisherUrl = "templates/byPublisher";
var getTemplateByUserUrl = "templates/byPublisherAndCurrentUser";
var updateDefaultTemplateUrl = "templates/updateDefaultTemplate";
var updateUserTemplateUrl = "templates/updateUserTemplate";
var getWidgetUrl = "widgets";
var getMediaUrl = "medias/search";
var getInventoryUrl = "inventories/search";
var getDataWidgetUrl = "widgets/getData";
var getMetricUrl = "metrics";
var getCalendarWidget = "notes";
var changeLevelWidgetUrl = "widgets/getValueForDataLevel";
var getPlatformsUrl = "platforms";
var getPlatformInventoriesUrl = "inventoryPlatform/search";
var getPlatformGroupsUrl = "platformGroups";
var getNoteListUrl = "notes/getNotePaging";
export var getTemplateByPublisher = function (publisherId) {
    var requestParams = {
        publisherIds: publisherId
    };
    return userClient.get(getTemplateByPublisherUrl, { params: requestParams });
};
export var getTemplateByUser = function (publisherId) {
    var requestParams = {
        publisherIds: publisherId
    };
    return userClient.get(getTemplateByUserUrl, { params: requestParams });
};
export var updateDefaultTemplate = function (data) {
    return userClient.put("" + updateDefaultTemplateUrl, data);
};
export var updateUserTemplate = function (data) {
    return userClient.put("" + updateUserTemplateUrl, data);
};
export var getWidgets = function (param) {
    return userClient.get(getWidgetUrl, { params: param });
};
export var getMedias = function (params) {
    return userClient.get(getMediaUrl, { params: params });
};
export var getInventories = function (params) {
    return userClient.get(getInventoryUrl, { params: params });
};
export var getDataWidgets = function (body, source) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, userClient.post(getDataWidgetUrl, body, { cancelToken: source === null || source === void 0 ? void 0 : source.token })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getMetrics = function () {
    return userClient.get(getMetricUrl);
};
export var getWidgetDetails = function (widgetCode) {
    return userClient.get(getWidgetUrl + "/" + widgetCode);
};
export var getWidgetCalendar = function (params, source) {
    return userClient.get("" + getCalendarWidget, { params: params, cancelToken: source === null || source === void 0 ? void 0 : source.token });
};
export var getNoteByID = function (id) {
    return userClient.get(getCalendarWidget + "/" + id);
};
export var createNoteCalendar = function (body) {
    return userClient.post("" + getCalendarWidget, body);
};
export var updateNoteCalendar = function (body, id) {
    return userClient.put(getCalendarWidget + "/" + id, body);
};
export var deleteNoteCalendar = function (id) {
    return userClient.delete(getCalendarWidget + "/" + id);
};
export var getNoteList = function (params) {
    return userClient.get(getNoteListUrl, { params: params });
};
export var chandleLevelWidget = function (params) {
    return userClient.get("" + changeLevelWidgetUrl, { params: params });
};
export var getPlatforms = function () {
    return userClient.get(getPlatformsUrl);
};
export var getPlatformInventories = function (params) {
    return userClient.get(getPlatformInventoriesUrl, { params: params });
};
export var getPlatformGroups = function () {
    return userClient.get(getPlatformGroupsUrl);
};
